import type { NotificationCategory } from "@safeplate/contracts";

import { requestApi } from "../api/client.js";

export interface InboxItem {
  body: string | null;
  category: NotificationCategory;
  created_at: string;
  deep_link: string | null;
  entity_id: string | null;
  entity_type: string | null;
  id: string;
  read_at: string | null;
  title: string;
}

export interface InboxPageData {
  items: InboxItem[];
  next_cursor: string | null;
}

// Dashboard and inbox poll every five minutes; TanStack skips hidden tabs.
export const INBOX_POLL_MS = 300_000;

export function inboxQueryKey(orgId: string): readonly [string, string] {
  return ["notifications", orgId];
}

export function listInbox(orgId?: string): Promise<InboxPageData> {
  return requestApi("/notifications?limit=50", {
    ...(orgId ? { headers: { "X-Org-Id": orgId } } : {}),
  });
}

export function markInboxRead(ids: string[]): Promise<{ marked: number }> {
  return requestApi("/notifications/read", {
    body: JSON.stringify({ ids }),
    method: "POST",
  });
}

export function unreadCount(items: readonly InboxItem[] | undefined): number {
  return items?.filter((item) => !item.read_at).length ?? 0;
}

export const categoryLabels: Record<NotificationCategory, string> = {
  billing: "Plan",
  digest: "Summary",
  manager_attention: "Attention",
  renewal: "Renewal",
  system: "SafePlate",
  task_overdue: "Missed check",
  task_reminder: "Reminder",
};
